import { createFileRoute, redirect } from "@tanstack/react-router";
import { ForbiddenError } from "../../../../errors/ForbiddenError";

export const Route = createFileRoute("/_private/vbuyer/rnm_requests/new_us")({
  beforeLoad({ context }) {
    if (!context.auth.user?.roles_names.includes("Create Material requests")) {
      throw new ForbiddenError();
    }

    throw redirect({ to: "/vbuyer/rnm_requests/new" });
  },
  component: () => null,
});
